// extracted by mini-css-extract-plugin
export default {"select":"style_select__i5X5S","tag-number-1":"style_tag-number-1__e73sA","tag-number-2":"style_tag-number-2__JuCkj"};